import { BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext, useMemo } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import { CompiledDailyEngagedUsersPlainInfotmationRow } from '../styles';

const CompiledPlanInformationsComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState } = useContext(DailyEngagedUsersContext);

  const planContent = useMemo(() => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return content.formatString(
        content.compiledDailyEngagedUserInformation.planInformation,
        compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.metric.quantity.toLocaleString(),
      );
    } else {
      return content.formatString(content.compiledDailyEngagedUserInformation.planInformation, '--');
    }
  }, [compiledDailyEngagedUserDataState]);

  return (
    <CompiledDailyEngagedUsersPlainInfotmationRow>
      <BdsTypo tag="h4" variant="fs-20" bold="bold" margin={false} >
        {planContent}
      </BdsTypo>
      <BdsTypo variant="fs-14">
        {content.compiledDailyEngagedUserInformation.filter}
      </BdsTypo>    
    </CompiledDailyEngagedUsersPlainInfotmationRow>
  );
};

export default CompiledPlanInformationsComponent;
